import { Link, Offer, NameBanner } from '@rumblefish/ui/Rumblefish23Theme';

import { nftServicesData } from './NftServices.data';
import type { NftServicesProps } from './NftServices.types';
import {
  StyledStack,
  StyledButton,
  StyledSection,
  StyledLinkWrapper,
  SectionNameBannerStack,
} from './styles';

export const NftServices = ({
  offerRef,
  ...props
}: NftServicesProps): React.ReactElement => {
  return (
    <>
      <StyledSection width="normal">
        <StyledStack {...props}>
          <SectionNameBannerStack>
            <NameBanner type="section" text="Services" color="green" />
          </SectionNameBannerStack>
        </StyledStack>
      </StyledSection>

      <Offer
        title={nftServicesData.mainText}
        description={nftServicesData.description}
        data={nftServicesData.services}
        CustomButton={
          <StyledLinkWrapper>
            <Link to="/contact">
              <StyledButton>Book a free consultation</StyledButton>
            </Link>
          </StyledLinkWrapper>
        }
        ref={offerRef}
      />
    </>
  );
};
